<template>
  <div>
    <nuxt-img
      :src="value.config.image || placeholder"
      :alt="value.config.alt"
      class="rounded-md max-w-full"
      :class="widgetClasses"
      format="webp"
      quality="80"
      placeholder
      loading="lazy"
    />
  </div>
</template>

<script>
import placeholder from '@/assets/images/placeholder.jpg'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    widgetClasses: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    placeholder: () => placeholder,
  },
}
</script>
